import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSortAsc(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M4 17a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H4ZM4 13a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2H4ZM3 10a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1ZM4 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM18 6a1 1 0 1 0-2 0v6.132l-1.445-.964a1 1 0 1 0-1.11 1.664L17 15l3.555-2.168a1 1 0 0 0-1.11-1.664L18 12.132V6Z"
      />
    </BaseIcon>
  );
}
